module.exports = __webpack_public_path__ + "media/images/redesign-images/collegiate/college-store/indiana-university-f787088b1d91a91ced81791f1a5cf356.jpg";